import AppNetworkQuestions from './AppNetworkQuestions';

export default AppNetworkQuestions;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkQuestions/index.ts